import React, { useEffect, useState } from "react";
import OurLayouts from "../layout";
import labnewicon from "../../assets/labnewicon.svg";
import axios from "axios";
import { format } from "date-fns";
import { Calendar } from "primereact/calendar";
import nodata from "../../assets/nodata.svg";
import { toast } from "react-toastify";
import { Tabs, Modal, Radio, Select, Button, Input, Pagination } from "antd";
import customericon from "../../assets/Customer.svg";
import TrackEnquiry from "./TrackEnquiry";
import OrderDetailsModal, {
  OrderDetailsSection,
  OrderDetailsTable,
  formatLabCollectionDate,
  orderTableCellClass,
  orderTableHeadClass,
} from "../shared/OrderDetailsModal";

const ClinicRadiologyDetails = () => {
  const [orders, setOrders] = useState([]);
  const [filters, setFilters] = useState({
    orderId: "",
    fromDate: format(new Date(), "yyyy-MM-dd"),
    toDate: format(new Date(), "yyyy-MM-dd"),
  });
  const API_URL = process.env.REACT_APP_API_URL;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isModalVisible2, setIsModalVisible2] = useState(false);
  const [ticketdata, setTicketdata] = useState();
  const [isTrackOrderModalVisible, setIsTrackOrderModalVisible] = useState(false);
  const [orderStatusData, setOrderStatusData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [reportUrl, setReportUrl] = useState("");
  const [enquiryModalVisible, setEnquiryModalVisible] = useState(false);
  const [queryDescription, setQueryDescription] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [totalElements, setTotalElements] = useState(0);
    const hospitalId = localStorage.getItem("hospitalid") || "";
  const handleViewDetails = (order) => {
    setSelectedOrder(order);
    setIsModalVisible(true);
  };
  useEffect(() => {
    fetchOrders();
  }, [filters]);

   const handlePageChange = (page) => {
    fetchOrders(page);
  };

  async function fetchOrders(page = currentPage) {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
      const clinicId = localStorage.getItem("clinicId");
    try {
      const resp = await axios.get(
        `${API_URL}orders?orderType=lab&subServiceType=radiology&clinicId=${clinicId}` +
          `&fromDate=${filters.fromDate}` +
          `&toDate=${filters.toDate}` +
          (filters.orderId ? `&id=${filters.orderId}` : "") +
          `&page=${page - 1}&size=${pageSize}`,
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        }
      );
      setOrders(resp.data.records || []);
      setTotalElements(resp.data.totalElements || 0);
      setCurrentPage(page);
    } catch (err) {
      console.error("Fetch error:", err.response || err);
    }
  }

   const handleEnquiryModal = (order) =>{
    setSelectedOrder(order);
    setEnquiryModalVisible(true); 
    setQueryDescription(''); // Reset the input each time modal opens
  }
    const handleEnquiryModalClose = () => {
    setEnquiryModalVisible(false);
    setSelectedOrder(null);
  };
  const handleEnquiry = async () => {
    console.log(selectedOrder, selectedOrder.patientId, "order");
    const token = localStorage.getItem("auth_token");
        const tenantId = localStorage.getItem("tenantId");
    const response = await axios.get(
      `${API_URL}patient/search?patientId=${selectedOrder.patientId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
      }
    );
    if(response?.data.data.length == 0){
      toast.error("No Patient Found")
      return
    }

    const Patientdata = response?.data.data[0];
    const payload = {
      patientDetails: {
        // patientdetailsid: "",
        patientId: selectedOrder.patientId,
        medicaseId: "",
        patientName: `${Patientdata.firstName} ${Patientdata.lastName}`,
        dob: Patientdata.dob,
        gender: Patientdata.gender,
        mobileNumber: Patientdata.mobileNumber,
        email: "",
        escallationNumber: "",
        address: Patientdata.address || selectedOrder?.address,
        pincode: Patientdata.pinCode,
      },
      serviceDetailsMessage: queryDescription,
      tickeType: "LAB_TEST",
      ticketSource: "HOSPITAL360",
      hospitalId: hospitalId,
    };
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_COMMAND_CENTER_URL}patient/add-ticket-d2c`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const Data = await res.json();
      if (Data.status == 200) {
        toast.success(Data.message);

        // Make the second API call with the ticket ID from the first response
        const ticketId = Data.data.id;
        const orderId = selectedOrder.id;

        try {
          const secondRes = await fetch(
            `${API_URL}createenquiry/order?orderId=${orderId}`,
            {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                tenantId: tenantId,
              },
              body: JSON.stringify({
                ticketId: ticketId,
                ticketStatus: "INPROGRESS",
            
              }),
            }
          );

          if (secondRes.ok) {
            // Handle plain text response
            const responseText = await secondRes.text();
            toast.success(responseText || "Enquiry ticket added successfully");
            console.log("Second API response:", responseText);
            setEnquiryModalVisible(false);
               setSelectedOrder(null);
               setQueryDescription('');
            // Reload the page to show updated status
            window.location.reload();
          } else {
            // Try to get error message from response
            let errorMessage = "Failed to create enquiry. Please try again later.";
            try {
              const errorData = await secondRes.json();
              errorMessage = errorData.message || errorMessage;
            } catch (e) {
              // If JSON parsing fails, try text
              try {
                const errorText = await secondRes.text();
                errorMessage = errorText || errorMessage;
              } catch (textError) {
                console.error("Could not parse error response:", textError);
              }
            }
            toast.error(errorMessage);
            console.error("Second API error:", errorMessage);
          }
        } catch (secondError) {
          toast.error("Failed to create enquiry. Please try again later.");
        }
      } else {
        toast.error("Failed to register ticket. Please try again later.");
      }
      console.log(Data, "dxfghj");
    } catch (error) {
      console.error("Failed to register ticket", error);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSearch = () => {
    fetchOrders();
  };

  const handleReset = () => {
    setFilters({
      orderId: "",
      fromDate: format(new Date(), "yyyy-MM-dd"),
      toDate: format(new Date(), "yyyy-MM-dd"),
    });
  };

   const handleTrackEnquiry = async (order) => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    // Get the first ticket ID from the enquiryTickets array
    const ticketId = order.enquiryTickets[0].ticketId;

    console.log("Calling API with ticketId:", ticketId);
    console.log("Order enquiryTickets:", order.enquiryTickets);

    // Call the API to get ticket details
    const response = await fetch(
      `${process.env.REACT_APP_API_COMMAND_CENTER_URL}patient/ticket/${ticketId}`,
      {
        method: "GET",
        headers: {
          accept: "application/json",

        },
      }
    );

    console.log("API Response status:", response.status);
    console.log("API Response:", response);

    const ticketData = await response.json();
    setTicketdata(ticketData.data)
    console.log("Ticket details:", ticketData);
  setIsModalVisible2(true);
    // toast.success(`API called successfully! Ticket ID: ${ticketId}`);
  };

  const API_NEW_URL = process.env.REACT_APP_API_NEW_URL;

  const handleTrackOrder = async (order) => {
    setLoading(true);
    try {
      // Extract order ID from the order object
      const orderNo = order?.labTests?.labOrderId 
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      
      if (!orderNo) {
        toast.error("Order number not found");
        return;
      }
      
      console.log("Calling API with order ID:", orderNo);

      const response = await fetch(
        `${API_NEW_URL}orderloader/order-status?orderNo=${orderNo}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        }
      );

      console.log("API Response status:", response.status);

      if (response.ok) {
        const data = await response.json();
        console.log("API Response data:", data);
        setOrderStatusData(data);
        setIsTrackOrderModalVisible(true);
        toast.success("Order status fetched successfully!");
      } else {
        const errorText = await response.text();
        console.error("API Error response:", errorText);
        toast.error("Failed to fetch order status");
      }
    } catch (error) {
      console.error("Error tracking order:", error);
      toast.error("Error tracking order. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleViewReport = (docUrl) => {
    // Construct the full URL using the Google Cloud Storage API
    const baseUrl = process.env.REACT_APP_API_GOOGLE_URL;
    
    // Ensure the report path doesn't already include the base URL
    const fullReportUrl = docUrl.startsWith('http') 
      ? docUrl 
      : `${baseUrl}${docUrl}`;
    
    setReportUrl(fullReportUrl);
    setShowReportModal(true);
  };

  return (
    <OurLayouts>
      <div className="min-h-screen p-4 bg-[#f1f8f7] rounded-lg">
        <div className="max-w-6xl mx-auto">
          <div className="bg-[#F0F9FB] min-h-screen rounded-lg">
            <div className="flex items-center justify-between mb-3">
              <h2 className="text-xl font-semibold text-[#003F6B]">
                Radiology Orders
              </h2>
            </div>

            {/* Filter Form */}
            <div className="rounded-lg shadow-sm mb-6">
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Order ID
                  </label>
                  <input
                    type="text"
                    name="orderId"
                    value={filters.orderId}
                    onChange={handleFilterChange}
                    className="w-full p-2 border border-gray-300 rounded-md"
                    placeholder="Enter Order ID"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    From Date
                  </label>
                  <input
                    type="date"
                    name="fromDate"
                    value={filters.fromDate}
                    onChange={handleFilterChange}
                    className="w-full p-2 border border-gray-300 rounded-md"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    To Date
                  </label>
                  <input
                    type="date"
                    name="toDate"
                    value={filters.toDate}
                    onChange={handleFilterChange}
                    className="w-full p-2 border border-gray-300 rounded-md"
                  />
                </div>
                <div className="flex items-end space-x-2">
                  <button
                    onClick={handleSearch}
                    className="bg-[#003F6B] text-white px-4 py-2 rounded-md text-sm font-medium"
                  >
                    Search
                  </button>
                  <button
                    onClick={handleReset}
                    className="border border-[#003F6B] text-[#003F6B] px-4 py-2 rounded-md text-sm font-medium"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>

            {orders.length > 0 ? (
              <>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {orders.map((order, index) => (
                  <div
                    key={index}
                    className="bg-white border border-gray-200 rounded-xl p-4 flex gap-4 shadow-sm"
                  >
                    <div className="flex-shrink-0">
                      <img src={labnewicon} alt="Radiology Icon" />
                    </div>

                    <div className="flex-1">
                      <div className="flex justify-between items-start">
                        <div>
                          <h3 className="text-[#004276] font-semibold text-base mb-1">
                            {order?.patientName}
                          </h3>
                          {order?.labTests && (
                            <p className="text-[#004276] font-normal text-base mb-1">
                              <span className="font-medium">Order Id:</span>{" "}
                              <span className="font-medium text-sm">
                                {order.id}
                              </span>{" "}
                            </p>
                          )}
                        </div>
                        {(!order.enquiryTickets || order.enquiryTickets.length === 0) && (
                          <img
                            className="cursor-pointer w-8 h-8"
                            title="Customer Support"
                            src={customericon}
                            alt="Customer"
                            onClick={() => handleEnquiryModal(order)}
                          />
                        )}
                      </div>

                      <hr className="my-2 border-gray-200" />

                      <div className="mt-4 flex justify-center gap-2">
                        <button
                          className="border border-[#003F6B] hover:bg-[#003F6B] hover:text-white text-[#003F6B] px-3 py-1.5 rounded text-xs font-medium transition-colors duration-200"
                          onClick={() => handleViewDetails(order)}
                        >
                          View Details
                        </button>
                        <button
                          className="border border-[#FF6B35] hover:bg-[#FF6B35] hover:text-white text-[#FF6B35] px-3 py-1.5 rounded text-xs font-medium transition-colors duration-200"
                          onClick={() => handleTrackOrder(order)}
                          disabled={loading}
                        >
                          {loading ? "Loading..." : "Track Order"}
                        </button>
                        {order.enquiryTickets && order.enquiryTickets.length > 0 && (
                          <button
                            className="border border-[#00B77E] hover:bg-[#00B77E] hover:text-white text-[#00B77E] px-3 py-1.5 rounded text-xs font-medium transition-colors duration-200"
                            onClick={() => handleTrackEnquiry(order)}
                          >
                            Track Enquiry
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="flex justify-center mt-6">
                  <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={totalElements}
                    onChange={handlePageChange}
                    showSizeChanger={false}
                  />
                </div>
              </>
            ) : (
              <div className="flex flex-col items-center justify-center h-full text-gray-500">
                <img src={nodata} alt="No Data" className="w-64 h-64 mb-4" />
                <div className="text-center text-gray-600">
                  No orders found for the selected filters.
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {isModalVisible && selectedOrder && (
        <OrderDetailsModal
          open={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          subtitle="Radiology Order Details"
          patientName={selectedOrder.patientName}
          status={selectedOrder.enquiryTickets?.[0]?.ticketStatus}
          address={selectedOrder.address}
          addressLabel="Delivery Address"
          infoFields={[
            {
              label: "Lab Order ID",
              value: selectedOrder.labTests?.labOrderId,
              mono: true,
            },
            {
              label: "Collection Date",
              value: formatLabCollectionDate(
                selectedOrder.labTestDateAndTime?.collectionDate
              ),
            },
            {
              label: "Collection Time",
              value: selectedOrder.labTestDateAndTime?.collectionTime,
            },
            { label: "Mobile No", value: selectedOrder.patientMobileNo },
          ]}
        >
          <OrderDetailsSection title="Test Details">
            <OrderDetailsTable>
              <thead>
                <tr>
                  <th className={`${orderTableHeadClass} text-left`}>Test Name</th>
                  <th className={`${orderTableHeadClass} text-left`}>Lab Partner</th>
                  <th className={`${orderTableHeadClass} text-right`}>Unit Price</th>
                  <th className={`${orderTableHeadClass} text-right`}>Unit Price After Discount</th>
                </tr>
              </thead>
              <tbody>
                {selectedOrder.labTests?.labTests?.map((lab, index) => (
                  <tr key={index}>
                    <td className={orderTableCellClass}>{lab.labTestName}</td>
                    <td className={orderTableCellClass}>{lab.labPartnerName}</td>
                    <td className={`${orderTableCellClass} text-right`}>
                      ₹{lab.amount || 0}
                    </td>
                    <td className={`${orderTableCellClass} text-right`}>
                      ₹{Number(lab.discountedAmount || 0).toFixed(2)}
                    </td>
                  </tr>
                ))}
                <tr className="bg-[#F9FAFB]">
                  <td colSpan="3" className={`${orderTableCellClass} font-bold`}>
                    Total Amount
                  </td>
                  <td className={`${orderTableCellClass} text-right font-bold text-[#00B77E]`}>
                    ₹
                    {selectedOrder.labTests?.labTests
                      ?.reduce(
                        (sum, lab) => sum + Number(lab.discountedAmount || 0),
                        0
                      )
                      .toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </OrderDetailsTable>
          </OrderDetailsSection>
        </OrderDetailsModal>
      )}
      {isModalVisible2 && (
        <TrackEnquiry isModalVisible2={isModalVisible2} setIsModalVisible2={setIsModalVisible2} ticketdata={ticketdata}/>
        
      )}
      {isTrackOrderModalVisible && (
        <Modal
          title="Order Status"
          open={isTrackOrderModalVisible}
          onCancel={() => setIsTrackOrderModalVisible(false)}
          footer={null}
          width={800}
        >
          {orderStatusData && (
            <div className="space-y-4">
              <div className="bg-gray-50 p-4 rounded-lg">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <strong>Order No:</strong> {orderStatusData?.orderNo || 'N/A'}
                  </div>
                  <div>
                    <strong>Service Type:</strong> {orderStatusData?.serviceType || 'N/A'}
                  </div>
                  <div>
                    <strong>Latest Status:</strong> 
                    <span className={`ml-2 px-2 py-1 rounded text-xs font-medium ${
                      orderStatusData?.latestStatus === "REPORT UPLOADED" 
                        ? "bg-green-100 text-green-800" 
                        : "bg-blue-100 text-blue-800"
                    }`}>
                      {orderStatusData?.latestStatus || 'N/A'}
                    </span>
                  </div>
                  <div>
                    <strong>Status Date:</strong> {orderStatusData?.statusDate ? new Date(orderStatusData.statusDate).toLocaleDateString() : 'N/A'}
                  </div>
                </div>
              </div>

              {orderStatusData?.labOrderDocs && orderStatusData.labOrderDocs.length > 0 && (
                <div>
                  <h4 className="font-semibold text-lg mb-3">Reports Available</h4>
                  <div className="space-y-2">
                    {orderStatusData.labOrderDocs.map((doc, index) => (
                      <div key={index} className="flex items-center justify-between bg-blue-50 p-3 rounded-lg">
                        <span className="text-sm text-gray-700">
                          Report {index + 1}: {doc}
                        </span>
                        <button
                          onClick={() => handleViewReport(doc)}
                          className="bg-blue-600 text-white px-3 py-1 rounded text-xs font-medium hover:bg-blue-700 transition-colors"
                        >
                          View Report
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div>
                <h4 className="font-semibold text-lg mb-3">Status History</h4>
                <div className="space-y-2">
                  {orderStatusData?.statusHistory && orderStatusData.statusHistory.length > 0 ? (
                    orderStatusData.statusHistory.map((status, index) => (
                      <div key={index} className="flex items-center justify-between bg-gray-50 p-3 rounded-lg">
                        <div>
                          <span className="font-medium">{status.status}</span>
                         
                        </div>
                        <div className="text-sm text-gray-500">
                          {status.statusDate ? new Date(status.statusDate).toLocaleDateString() : 'N/A'}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-gray-500 text-center py-4">
                      No status history available
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </Modal>
      )}

      {/* Report View Modal */}
      {showReportModal && (
        <Modal
          title="View Report"
          open={showReportModal}
          onCancel={() => setShowReportModal(false)}
          footer={null}
          width="90%"
          style={{ top: 20 }}
          bodyStyle={{ height: '80vh', padding: 0 }}
        >
          <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ flex: 1, border: 'none' }}>
              <iframe
                src={reportUrl}
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none',
                  borderRadius: '4px'
                }}
                title="Report Viewer"
                onError={() => {
                  toast.error("Failed to load report. Please try again.");
                  setShowReportModal(false);
                }}
              />
            </div>
          </div>
        </Modal>
      )}

          <Modal
              title="Order Enquiry"
              visible={enquiryModalVisible}
              onCancel={handleEnquiryModalClose}
              footer={[
                <Button key="back" onClick={handleEnquiryModalClose}>
                  Cancel
                </Button>,
                <Button key="submit" type="primary" onClick={handleEnquiry}>
                  Submit
                </Button>,
              ]}
            >
              {selectedOrder && (
                <div>
                  <p><strong>Order ID:</strong> {selectedOrder.id}</p>
                  <p><strong>Patient Name:</strong> {selectedOrder?.patientName}</p>
      
                  <Input.TextArea
                    rows={4}
                    value={queryDescription}
                    onChange={(e) => setQueryDescription(e.target.value)}
                    placeholder="Enter your query description here..."
                  />
                </div>
              )}
            </Modal>
    </OurLayouts>
  );
};

export default ClinicRadiologyDetails;
